export default [
  {
    description: 'ATIVAR AÇÃO',
    regexVisualOrigem: '',
    regexVisualDestino: '',
    alliasRegexOrigem: '',
    alliasRegexDestino: '',
    active: true,
    acao: {
      description: 'ATIVAR AÇÃO',
      class: 'Modules\\Agi\\Entities\\acoes\\ChangeToTrueActiveRegex',
      centroDeCusto: '',
      tag: [],
      tipoRota: '',
      rota_description: '',
      regex_prioridade: '',
      continuar: false,
    },
  },
  {
    description: 'DESATIVAR AÇÃO',
    regexVisualOrigem: '',
    regexVisualDestino: '',
    alliasRegexOrigem: '',
    alliasRegexDestino: '',
    active: true,
    acao: {
      description: 'DESATIVAR AÇÃO',
      class: 'Modules\\Agi\\Entities\\acoes\\ChangeToFalseActiveRegex',
      centroDeCusto: '',
      tag: [],
      rota_description: '',
      regex_prioridade: '',
      continuar: false,
    },
  },
  {
    description: 'DISCAR PARA FILA',
    regexVisualOrigem: '',
    regexVisualDestino: '',
    alliasRegexOrigem: '',
    alliasRegexDestino: '',
    active: true,
    acao: {
      description: 'DISCAR PARA FILA',
      class: 'Modules\\Agi\\Entities\\acoes\\DiscarFila',
      centroDeCusto: '',
      tag: [],
      record: true,
      tamanhoPrefixoOrigem: '',
      alterarOrigemPara: '',
      prefixoOrigem: '',
      sufixoOrigem: '',
      retiradaOrigem: '',
      addFinalOrigem: '',
      tempo: '90',
      origemTransfere: true,
      destinoTransfere: true,
      continuar: false,
      queue_id: '',
      verificaLoginOperadores: false,
      verificaOperadoresEmPausa: false,
    },
  },
  {
    description: 'DISCAR PARA GRUPO DE ATENDIMENTO',
    regexVisualOrigem: '',
    regexVisualDestino: '',
    alliasRegexOrigem: '',
    alliasRegexDestino: '',
    active: true,
    acao: {
      description: 'DISCAR PARA GRUPO DE ATENDIMENTO',
      class: 'Modules\\Agi\\Entities\\acoes\\DiscarGrupo',
      centroDeCusto: '',
      tag: [],
      record: true,
      tamanhoPrefixoOrigem: '',
      alterarOrigemPara: '',
      prefixoOrigem: '',
      sufixoOrigem: '',
      retiradaOrigem: '',
      addFinalOrigem: '',
      tempo: '90',
      origemTransfere: true,
      destinoTransfere: true,
      continuar: false,
      grupo_id: '',
    },
  },
  {
    description: 'DISCAR PARA OPERADOR',
    regexVisualOrigem: '',
    regexVisualDestino: '',
    alliasRegexOrigem: '',
    alliasRegexDestino: '',
    active: true,
    acao: {
      description: 'DISCAR PARA OPERADOR',
      class: 'Modules\\Agi\\Entities\\acoes\\DiscarAgente',
      centroDeCusto: '',
      tag: [],
      record: true,
      tamanhoPrefixoOrigem: '',
      tamanhoPrefixoDestino: '',
      alterarOrigemPara: '',
      prefixoOrigem: '',
      retiradaOrigem: '',
      addFinalOrigem: '',
      alterarDestinoPara: '',
      prefixoDestino: '',
      retiradaDestino: '',
      addFinalDestino: '',
      tempo: '90',
      verificaOperadoresEmPausa: true,
      origemTransfere: true,
      destinoTransfere: true,
      habilitaRing: true,
      continuar: false,
    },
  },
  {
    description: 'DISCAR PARA PESQUISA',
    regexVisualOrigem: '',
    regexVisualDestino: '',
    alliasRegexOrigem: '',
    alliasRegexDestino: '',
    active: true,
    acao: {
      description: 'DISCAR PARA PESQUISA',
      class: 'Modules\\Agi\\Entities\\acoes\\DiscarPesquisa',
      centroDeCusto: '',
      record: true,
      continuar: true,
      pesquisas: [],
    },
  },
  {
    description: 'DISCAR PARA RAMAL',
    regexVisualOrigem: '',
    regexVisualDestino: '',
    alliasRegexOrigem: '',
    alliasRegexDestino: '',
    active: true,
    acao: {
      description: 'DISCAR PARA RAMAL',
      class: 'Modules\\Agi\\Entities\\acoes\\DiscarRamal',
      centroDeCusto: '',
      tag: [],
      record: true,
      tamanhoPrefixoOrigem: '',
      tamanhoPrefixoDestino: '',
      alterarOrigemPara: '',
      prefixoOrigem: '',
      retiradaOrigem: '',
      addFinalOrigem: '',
      alterarDestinoPara: '',
      prefixoDestino: '',
      retiradaDestino: '',
      addFinalDestino: '',
      tempo: '90',
      origemTransfere: true,
      destinoTransfere: true,
      habilitaRing: true,
      continuar: false,
      verifyStatusAgent: true,
    },
  },
  {
    description: 'DISCAR PARA SALA DE CONFERÊNCIA',
    regexVisualOrigem: '',
    regexVisualDestino: '',
    alliasRegexOrigem: '',
    alliasRegexDestino: '',
    active: true,
    acao: {
      description: 'DISCAR PARA SALA DE CONFERÊNCIA',
      class: 'Modules\\Agi\\Entities\\acoes\\DiscarConferencia',
      centroDeCusto: '',
      tag: [],
      salaConferencia: '',
      isAdmin: false,
      continuar: false,
    },
  },
  {
    description: 'DISCAR PARA TRONCO',
    regexVisualOrigem: '',
    regexVisualDestino: '',
    alliasRegexOrigem: '',
    alliasRegexDestino: '',
    active: true,
    acao: {
      description: 'DISCAR PARA TRONCO',
      class: 'Modules\\Agi\\Entities\\acoes\\DiscarTronco',
      centroDeCusto: '',
      tag: [],
      record: true,
      tamanhoPrefixoOrigem: '',
      tamanhoPrefixoDestino: '',
      alterarOrigemPara: '',
      prefixoOrigem: '',
      retiradaOrigem: '',
      addFinalOrigem: '',
      alterarDestinoPara: '',
      prefixoDestino: '',
      retiradaDestino: '',
      addFinalDestino: '',
      tempo: '90',
      origemTransfere: true,
      destinoTransfere: false,
      habilitaRing: false,
      tronco_id: '',
      continuar: false,
    },
  },
  {
    description: 'DISCAR PARA URA',
    regexVisualOrigem: '',
    regexVisualDestino: '',
    alliasRegexOrigem: '',
    alliasRegexDestino: '',
    active: true,
    acao: {
      description: 'DISCAR PARA URA',
      class: 'Modules\\Agi\\Entities\\acoes\\TocarUra',
      centroDeCusto: '',
      tag: [],
      ura_id: '',
      continuar: false,
    },
  },
  {
    description: 'EXECUTAR WEB HOOK',
    regexVisualOrigem: '',
    regexVisualDestino: '',
    alliasRegexOrigem: '',
    alliasRegexDestino: '',
    active: true,
    acao: {
      description: 'EXECUTA WEBHOOK',
      class: 'Modules\\Agi\\Entities\\acoes\\ExecutaWebHooks',
      centroDeCusto: '',
      tag: [],
      webHook: '',
      continuar: false,
    },
  },
  {
    description: 'SELECIONAR MÚSICA DE ESPERA',
    regexVisualOrigem: '',
    regexVisualDestino: '',
    alliasRegexOrigem: '',
    alliasRegexDestino: '',
    active: true,
    acao: {
      description: 'SELECIONAR MÚSICA DE ESPERA',
      class: 'Modules\\Agi\\Entities\\acoes\\SetarMusicaEspera',
      centroDeCusto: '',
      tag: [],
      musica: '',
      continuar: true,
    },
  },
  {
    description: 'SETAR PESQUISA',
    regexVisualOrigem: '',
    regexVisualDestino: '',
    alliasRegexOrigem: '',
    alliasRegexDestino: '',
    active: true,
    acao: {
      description: 'SETAR PESQUISA',
      class: 'Modules\\Agi\\Entities\\acoes\\SetarPesquisa',
      centroDeCusto: '',
      record: true,
      continuar: true,
      pesquisas: [],
    },
  },
  {
    description: 'TOCAR ÁUDIO',
    regexVisualOrigem: '',
    regexVisualDestino: '',
    alliasRegexOrigem: '',
    alliasRegexDestino: '',
    active: true,
    acao: {
      description: 'TOCAR ÁUDIO',
      class: 'Modules\\Agi\\Entities\\acoes\\TocarAudio',
      centroDeCusto: '',
      tag: [],
      audio: '',
      continuar: false,
    },
  },
  {
    description: 'TOCAR SINAL DE OCUPADO',
    regexVisualOrigem: '',
    regexVisualDestino: '',
    alliasRegexOrigem: '',
    alliasRegexDestino: '',
    active: true,
    acao: {
      description: 'TOCAR SINAL DE OCUPADO',
      class: 'Modules\\Agi\\Entities\\acoes\\TocarSinalDeOcupado',
      centroDeCusto: '',
      tag: [],
      continuar: false,
    },
  },
  {
    description: 'VALIDAR SENHA',
    regexVisualOrigem: '',
    regexVisualDestino: '',
    alliasRegexOrigem: '',
    alliasRegexDestino: '',
    active: true,
    acao: {
      description: 'VALIDAR SENHA',
      class: 'Modules\\Agi\\Entities\\acoes\\ValidarSenha',
      centroDeCusto: '',
      tag: [],
      senha: '',
      continuar: false,
    },
  },
]
